export default "__VITE_ASSET__9416aca7__"